export default __webpack_public_path__ + "src/images/packages/kruger-sunset-lodge/dee060d4cdf6d59473aea9d299aeb9cf-2.jpg";